/** @jsxImportSource preact */
import type { ComponentChildren } from 'preact';

interface TextBubbleProps {
  role: 'assistant' | 'user' | 'system';
  children: ComponentChildren;
}

/**
 * Plain text message bubble. Children must be plain strings — JSX
 * interpolation guarantees Preact escapes them, so we never need to
 * call escapeHtml here.
 */
export function TextBubble({ role, children }: TextBubbleProps) {
  return (
    <div class={`lc-message ${role}`}>
      <div class="lc-message-bubble">{children}</div>
    </div>
  );
}
